module.exports = __webpack_public_path__ + "static/img/xiaotiao.405d6611.png";